import { render, staticRenderFns } from "./weightSubscribe.vue?vue&type=template&id=00f90c24&scoped=true&"
import script from "./weightSubscribe.vue?vue&type=script&lang=js&"
export * from "./weightSubscribe.vue?vue&type=script&lang=js&"
import style0 from "./weightSubscribe.vue?vue&type=style&index=0&id=00f90c24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f90c24",
  null
  
)

export default component.exports